import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IListItem, INewDonorRecipientBaseData, IRecipient } from '@nkr/models/index';

export interface INewDonorRecipientlookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            genderList: IListItem[],
            bloodTypeList: IListItem[],
            stateList: IListItem[],
            activePatientList: IRecipient[]
        }
    }
}

export interface IExistingMatch {
    id: number,
    aliasMatch: boolean,
    mrnMatch: boolean
}

export interface ICheckForExistingAliasAndMrnResponse {
    data: {
        success: boolean,
        message: string,
        results: IExistingMatch[]
    }
}

export interface INewDonorRecipientSaveResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            donorId: number,
            recipientId: number,
            messages?: string[]
        }
    }
}

export const ActionCreators = {
    getNewDonorRecipientLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<INewDonorRecipientlookupDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/new-donor-recipient/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    checkForExistingDonorAliasAndMrn:(centerId:number, alias:string,  mrn:string)=>async (dispatch: Dispatch<IApplicationState>): Promise<ICheckForExistingAliasAndMrnResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/new-donor-recipient/existing-donor-alias-mrn?alias=${alias}&mrn=${mrn}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    checkForExistingRecipientAliasAndMrn:(centerId:number, alias:string,  mrn:string)=>async (dispatch: Dispatch<IApplicationState>): Promise<ICheckForExistingAliasAndMrnResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/new-donor-recipient/existing-recipient-alias-mrn?alias=${alias}&mrn=${mrn}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    saveNewDonorRecipient: (centerId: number, type: number, existingRecipientId: number, donorDetails: INewDonorRecipientBaseData, recipientDetails: INewDonorRecipientBaseData) => async (dispatch: Dispatch<IApplicationState>): Promise<INewDonorRecipientSaveResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/new-donor-recipient`,
            data: {
                type,
                existingRecipientId,
                donorDetails,
                recipientDetails
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    saveNewPairedDonor: (centerId: number, existingRecipientId: number, donorDetails: INewDonorRecipientBaseData)=> async (dispatch: Dispatch<IApplicationState>): Promise<INewDonorRecipientSaveResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/new-paired-donor`,
            data: {
                existingRecipientId,
                donorDetails,
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}